// pages/AwayFromHome.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const AwayFromHome = () => (
  <>
    <title>Away from Home - Arthur Efremenko</title>
    <meta name="description" content={projects.awayFromHome.description} />
    <ProjectTemplate
      project={projects.awayFromHome}
      screenshots={projects.awayFromHome.screenshots}
    />
  </>
);

export default AwayFromHome;
